/**
 * Diese direktive schaut, ob im content oder im window gescrollt wurde und setzt die globale variable sticky auf true, sobald
 * mehr als 40 Pixel gescollt wurde.
 * Firefox scheint als einziger Browser nicht auf dem Content zu scrollen sondern auf dem Window. Deswegen muss auf der Scolllistener
 * auch auf dem Window gesetzt werden!
 */
import {IDirective, IDirectiveFactory, IDirectiveLinkFn, IAugmentedJQuery, IAttributes} from 'angular';

export default class DVScrollNav implements IDirective {
    static $inject = ['$window'];

    restrict = 'A';
    link: IDirectiveLinkFn;

    /* @ngInject */
    constructor($window: any) {

        this.link = (scope: any, element: IAugmentedJQuery, attrs: IAttributes, ctrl: any) => {

            angular.element('.serf-body__content').bind('scroll', function () {

                let top: any = angular.element('.serf-body__content').scrollTop();
                if (top >= 40) {
                    scope.sticky = true;
                } else {
                    scope.sticky = false;
                }
                scope.$apply();
            });

            // For whatever reason firefox does scroll on window and not on content!
            // This is for firefox browsers:
            angular.element($window).bind('scroll', function () {

                let top: any = angular.element($window).scrollTop();
                if (top >= 40) {
                    scope.sticky = true;
                } else {
                    scope.sticky = false;
                }
                scope.$apply();
            });

        };
    }

    static factory(): IDirectiveFactory {
        const directive = ($window: any) => new DVScrollNav($window);
        directive.$inject = ['$window'];
        return directive;
    }
}




// WEBPACK FOOTER //
// ./src/app/core/directive/dv-scroll-nav/dv-scroll-nav.ts